(() => {
  let adding = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-hbz-suggestion-add]');
    if (!button || adding) return;
    event.preventDefault();
    adding = true;
    const container = button.closest('.hbz-cart-suggestions');
    const status = container.querySelector('[role="status"]');
    const label = button.textContent;
    const buttons = document.querySelectorAll('[data-hbz-suggestion-add]');
    buttons.forEach((item) => { item.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.adding;
    status.textContent = '';
    const root = container.dataset.rootUrl.replace(/\/?$/, '/');
    let succeeded = false;
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.hbzSuggestionAdd), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('cart_add_failed');
      succeeded = true;
      button.textContent = button.dataset.added;
      status.textContent = button.dataset.addedMessage;
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('hbz:suggestion-added', { detail: { variantId: button.dataset.hbzSuggestionAdd } }));
    } catch (error) {
      button.textContent = label;
      status.textContent = button.dataset.error;
    } finally {
      button.removeAttribute('aria-busy');
      if (!succeeded) buttons.forEach((item) => { item.disabled = false; });
      adding = false;
    }
  });
})();
